export * from './id.viewModel';
export * from './dataHubRoute.viewModel';
export * from './hubRoutingWard.viewModel';
export * from './getDatasFromHub.viewModel';
export * from './hubRoutingCreateUpdate.viewModel';
export * from './keyValues.viewModel';
export * from './listUpdateStatus.viewModel';
export * from './ladingScheduleHistory.viewModel';
export * from './dataFilter.viewModel';
export * from './ladingScheduleHistory.viewModel';
export * from './dateRangeFromTo.viewModel';
export * from './priceServiceDetailExcel.viewModel';
export * from './priceUploadExcel.viewModel';
export * from './marker.viewModel';
export * from './shipmentReportEmp.viewModel';



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/index.ts